// import React, { useCallback, useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Modal, Button, Dropdown } from 'antd'
// import { ExclamationCircleOutlined, DownOutlined} from '@ant-design/icons'
// import { crmManageAccount, reload } from '../../utils/utils'
// import api from '../../https/api'

// export default function Logout() {
//   const navigate = useNavigate()
//   const [modal, contextHolder] = Modal.useModal();
//   const [items, setItems] = useState([])

//   // 获取本地存储完整用户信息
//   const currentUser = crmManageAccount() || {}
//   const { id: currentAdminId, account } = currentUser

//   const getQuestionList = useCallback(async () => {
//     if (items.length > 0) return;
//     const { data: { data } } = await api.getRoleSwitching({ name: account })
//     setItems(data)
//   }, [account, items.length])

//   useEffect(() => {
//     getQuestionList()
//   }, [getQuestionList])

//   // 匹配当前公司名称（顶部显示用）
//   const currentItem = items.find(item => Number(item.key) === Number(currentAdminId))
//   const currentCorpLabel = currentItem?.label || '加载中...'

//   // 过滤下拉列表：移除当前公司选项，只保留其他可切换项 + 退出登录
//   const filteredItems = currentAdminId
//     ? items.filter(item => Number(item.key) !== Number(currentAdminId))
//     : items

//   const logout = () => {
//     modal.confirm({
//       title: '提示',
//       icon: <ExclamationCircleOutlined />,
//       content: '确定要退出吗？',
//       okText: '确认',
//       cancelText: '取消',
//       onOk: () => {
//         localStorage.removeItem('crm_manage_account')
//         navigate('/login')
//       }
//     });
//   }

//   const onClick = ({ key }) => {
//     if (key === '999') {
//       logout()
//       return
//     }
//     modal.confirm({
//       title: '提示',
//       icon: <ExclamationCircleOutlined />,
//       content: '确定要切换角色吗？',
//       okText: '确认',
//       cancelText: '取消',
//       onOk: async () => {
//         const { data: { code, data } } = await api.getSwitchAccounts({ id: key })
//         if (code === 0) {
//           localStorage.setItem('crm_manage_account', JSON.stringify(data))
//           reload(0)
//           navigate('/index')
//         }
//       }
//     });
//   };

//   return (
//     <div className='userinfo'>
//       {/* 顶部当前公司正常显示 */}
//       <Button type='link'>当前公司：{currentCorpLabel}</Button>

//       {/* 下拉菜单使用过滤后的数据，不含当前公司 */}
//       <Dropdown menu={{ items: filteredItems, onClick }}>
//         <Button type='link'>账号：{account}<DownOutlined /></Button>
//       </Dropdown>

//       {contextHolder}
//     </div>
//   )
// }




import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, Button, Dropdown } from 'antd'
import { ExclamationCircleOutlined, DownOutlined} from '@ant-design/icons'
import { crmManageAccount, reload } from '../../utils/utils'
import api from '../../https/api'

export default function Logout() {
  const navigate = useNavigate()
  const [modal, contextHolder] = Modal.useModal();
  const [items, setItems] = useState([])

  // 获取本地存储完整用户信息
  const currentUser = crmManageAccount() || {}
  const { id: currentAdminId, account } = currentUser

  const getQuestionList = useCallback(async () => {
    if (items.length > 0) return;
    const { data: { data } } = await api.getRoleSwitching({ name: account })
    setItems(data)
  }, [account, items.length])

  useEffect(() => {
    getQuestionList()
  }, [getQuestionList])

  // 匹配当前公司名称
  const currentItem = items.find(item => Number(item.key) === Number(currentAdminId))
  const currentCorpLabel = currentItem?.label || '加载中...'

  // 过滤下拉列表：移除当前公司选项
  const filteredItems = currentAdminId
    ? items.filter(item => Number(item.key) !== Number(currentAdminId))
    : items

  const logout = () => {
    modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要退出吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        localStorage.removeItem('crm_manage_account')
        navigate('/login')
      }
    });
  }

  const onClick = ({ key }) => {
    if (key === '999') {
      logout()
      return
    }
    modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要切换角色吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        const { data: { code, data } } = await api.getSwitchAccounts({ id: key })
        if (code === 0) {
          localStorage.setItem('crm_manage_account', JSON.stringify(data))
          reload(0)
          navigate('/index')
        }
      }
    });
  };

  return (
    <div className='userinfo' style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 20,
      height: '100%',
      padding: '0 8px'
    }}>
      {/* 当前公司：纯文本展示，标签弱化，内容突出 */}
      <div className="current-corp">
        <span style={{ color: '#8c8c8c', fontSize: 13, marginRight: 4 }}>当前公司：</span>
        <span style={{ 
          color: '#262626', 
          fontSize: 14, 
          fontWeight: 500,
          opacity: currentCorpLabel === '加载中...' ? 0.6 : 1
        }}>
          {currentCorpLabel}
        </span>
      </div>

      {/* 账号下拉：按钮轻量化，图标精致化 */}
      <Dropdown menu={{ items: filteredItems, onClick }} placement="bottomRight">
        <Button 
          type="text" 
          style={{ 
            padding: '4px 10px', 
            height: 'auto',
            fontSize: 14,
            borderRadius: 4
          }}
        >
          <span style={{ color: '#8c8c8c', fontSize: 13, marginRight: 4 }}>账号：</span>
          <span style={{ color: '#262626' }}>{account}</span>
          <DownOutlined style={{ marginLeft: 6, fontSize: 12, color: '#bfbfbf' }} />
        </Button>
      </Dropdown>

      {contextHolder}
    </div>
  )
}
